import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { usePosContext } from '../PosContext';

export const PosProductListPagination = () => {
  const { config, page, handlePageChange, search, barcode } = usePosContext();

  if (search || barcode) return null;

  const hasNextPage = config?.config && page < config.config.length;
  const hasPreviousPage = page > 1;

  return (
    <Stack
      direction="row"
      spacing={2}
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      {hasPreviousPage && (
        <Button
          variant="text"
          onClick={() => handlePageChange(page - 1)}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
              transition: 'color 0.3s ease',
            },
          }}
        >
          <Icon icon={icon({ name: 'chevron-left' })} />
        </Button>
      )}

      {config?.config.map((_, index) => (
        <Button
          key={index}
          variant="text"
          onClick={() => handlePageChange(index + 1)}
          sx={{
            '&:hover': {
              bgcolor: 'transparent',
            },
          }}
        >
          <Typography
            sx={
              page === index + 1
                ? {
                    fontSize: 32,
                    color: 'primary.main',
                  }
                : {
                    fontSize: 24,
                    color: 'text.secondary',
                    '&:hover': {
                      color: 'primary.main',
                      transition: 'color 0.3s ease',
                    },
                  }
            }
          >
            •
          </Typography>
        </Button>
      ))}

      {hasNextPage && (
        <Button
          variant="text"
          onClick={() => handlePageChange(page + 1)}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
              transition: 'color 0.3s ease',
            },
          }}
        >
          <Icon icon={icon({ name: 'chevron-right' })} />
        </Button>
      )}
    </Stack>
  );
};
